module.exports = __webpack_public_path__ + "static/media/school_03.ef5911d0.webp";